module.exports = __webpack_public_path__ + "static/media/veracity.87414a6e.jpeg";